/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs'; 
import { FloorApi } from '../api/floor.api';
import { switchMap, map } from 'rxjs/operators';
import { FloorData, Floor } from '../../../interfaces/masters/floor';

@Injectable()
export class FloorService extends FloorData {

  constructor(private api: FloorApi) {
    super();
  }


  list(url: string): Observable<Floor[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<Floor>{
      return this.api.getById(url);
  }

  create(url: string, data:Floor): Observable<Floor[]> {
    return this.api.add(url,data);
  }

  update(url: string, data:Floor): Observable<Floor> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
